const d = {
  "animated-words": "animated-words",
  "animated-words__headline": "animated-words__headline",
  "animated-words__text-container": "animated-words__text-container",
  "animated-words__words-container": "animated-words__words-container",
  "animated-words__word": "animated-words__word",
  "animated-words__word--active": "animated-words__word--active",
  "animated-words__word--previous": "animated-words__word--previous",
  "animated-words__word--next": "animated-words__word--next",
  "animated-words__word--red": "animated-words__word--red",
  "animated-words__word--orange": "animated-words__word--orange",
  "animated-words__word--purple": "animated-words__word--purple",
  "animated-words__word--brand": "animated-words__word--brand",
  "animated-words__word--effect": "animated-words__word--effect",
  "animated-words--animated": "animated-words--animated"
};
export {
  d as default
};
